import bibleBookList from '../data/BookChapterList.json'

export default function sortBooks (books) {
  const bibleBookOrder = Object.keys(bibleBookList)
  books.sort(function(a, b) {
    return bibleBookOrder.indexOf(a) - bibleBookOrder.indexOf(b);
  });
  return books
}
